import React, { useEffect, useRef, useState } from "react";
import { Loader } from '../../components';
import { Banner, HeroTextInside, GalleryThumbs3d } from '../../components';
import { useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom';
import GoogleAds from './GoogleAds';
import postscribe from 'postscribe';

import {
  setLoader,
} from "../../redux/loader/loader.actions";
 
const ExperienceCommerceContainer = ({ isTestPage }) => {
  const history = useHistory();
  const heroImg = require('../../assets/header-experience.jpg');
  const arrayLoad = [
    heroImg
  ]
  const dispatch = useDispatch();

  const handleCLick = (slug) => {
      dispatch(setLoader(true))
      setTimeout(() =>{ 
        document.body.scrollTop = 0;
        history.push(slug)
      }, 500);
    
  }

  useEffect(() => {
    if(isTestPage){
      const parent = document.querySelector('.dcmads');
      var aScript = document.createElement('script');
      aScript.src = "https://www.googletagservices.com/dcm/dcmads.js";
      postscribe(parent, '<script async defer src="https://www.googletagservices.com/dcm/dcmads.js"></script>');
    }
  })

  return (
    <React.Fragment>
      <section className="experience-commerce"  >
      <HeroTextInside img={heroImg} text="Our full reality solution for your 3D Commerce"/>
      <div className="side--quote-wrap no-margin-btm">
        <h6 className="md--title side--title">Elevate your eCommerce</h6>
        <p className="preset-9 side--text">
        Modernize your UX with Invrsion’s 3D tech to allow your customers to twist, turn,
        flip and hyperzoom your product inventory. Increase your revenues and reduce store returns
        </p>
      </div>
      <GalleryThumbs3d />
      
      <div className="side--quote-wrap no-margin-btm">
        <h6 className="md--title side--title">Make your own products!</h6>
        <p className="preset-9 side--text">
        Select every detail of your product with the 3D Configurator. 
        </p>
      </div>
      <div className="banner--config-shirt">
        <div className="banner--config-shirt-wrapper">
         { !isTestPage && <img src={require('../../assets/column-image-shir.jpg')} />}
         
         { isTestPage && <GoogleAds />}
          <div className="banner--config-text">
            <p className="preset-10 text-side">
              Pick the materials, color and textures with a click as if you were really in a physical store. Configure your product and buy it with a simple click
              <br/><br/>
              Our 3D configurator is so disruptive that you will have more benefits than in-store shopping. 
            </p>
            <div className="rounded--cta full-color" onClick={() => handleCLick('/3d-commerce-experience/configurator')}>
              Try it
            </div>
          </div>
        </div>
      </div>
      <Banner 
          text="Intrigued? Let’s have a chat." route="/contact-us" copyRoute="Reach out" 
        />
      <Loader arrayLoad={arrayLoad} />

      </section>
    </React.Fragment>
  );
}

export default ExperienceCommerceContainer;
